import { App } from "@capacitor/app";
import semver from "semver";

import { isNativePlatform } from "utils/platform.helpers";

export const MIN_REQUIRED_APP_VERSION = "1.403.0"; // V3

export const getAppVersion = async (): Promise<string | null> => {
  if (!isNativePlatform()) {
    console.log("[RMD]: App version not available.");
    return null;
  }

  try {
    const info = await App.getInfo();
    console.log("[RMD]: App Version", info);

    return convertToValidVersion(info.version);
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const isAppVersionOutdated = (version: string): boolean => {
  try {
    const validVersion = convertToValidVersion(version);

    return !!(
      validVersion && semver.lt(validVersion, MIN_REQUIRED_APP_VERSION)
    );
  } catch (e) {
    console.error(e);
    return false;
  }
};

const convertToValidVersion = (version: string): string => {
  return version.replace("-dev", "");
};
